import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import DialogModal from "../DialogModal";
import { containsHtmlElement, convertUrlToLink } from "../../../utils/utils";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    borderRadius: "10px",
    margin: "auto",
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "600px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    borderRadius: "10px",
    textAlign: "left",
  },

  titleContainer: {
    marginBottom: "20px",
    fontSize: "20px",
    fontWeight: "bold",
    whiteSpace: "pre-wrap",
    "& p": {
      padding: 0,
      margin: 0,
    },
  },

  bodyContainer: {
    fontSize: "13px",
    whiteSpace: "pre-wrap",
    "& p": {
      padding: 0,
      margin: 0,
    },
  },
});

class RecommendRelocationPersonnelNotificationDialog extends React.Component {
  render() {
    const { classes, isOpen, toggleDialog, item } = this.props;
    const messageHead = convertUrlToLink(item.message_head);
    const messageBody = item.message_body;

    if (item) {
      return (
        <DialogModal
          open={isOpen}
          onClose={toggleDialog}
          aria-labelledby="pop-up-window"
          maxWidth={false}
          classes={{
            paper: classes.paper,
            contentContainer: classes.contentContainer,
          }}
        >
          <div className={classes.titleContainer}>
            {containsHtmlElement(messageHead) ? (
              <span dangerouslySetInnerHTML={{ __html: messageHead }} />
            ) : (
              <p>{item.message_head}</p>
            )}
          </div>

          {!!item.message_body && (
            <div className={classes.bodyContainer}>
              {containsHtmlElement(messageBody) ? (
                <span dangerouslySetInnerHTML={{ __html: messageBody }} />
              ) : (
                <p>{item.message_body}</p>
              )}
            </div>
          )}
        </DialogModal>
      );
    } else {
      return <div></div>;
    }
  }
}

RecommendRelocationPersonnelNotificationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  item: PropTypes.object,
};

export default withStyles(styles)(RecommendRelocationPersonnelNotificationDialog);



// WEBPACK FOOTER //
// ./src/components/common/NotificationBell/RecommendRelocationPersonnelNotificationDialog.jsx